import { axios, getResponse, isUndNullEmp, settings } from '../../helpers/main';
import { userAuthContextType } from '../../auth/AuthProvider';

const authServices = { user: userAuthContextType }; //eslint-disable-line
const objectSerice = getResponse({ type: 0 }); //eslint-disable-line

export const RoleService = {
    /**
     * Obtiene todos los roles destinados a la gestión de usuarios.
     * @param {Object} params - Parámetros de la función.
     * @param {authServices} params.auth - Objeto de autenticación distribuido por useAuth.
     * @param {Number} params.languageId - ID del lenguaje actual.
     * @param {String} [params.subMethod] - Nombre del sub-método para trazabilidad (opcional).
     * @returns {Promise<objectSerice>} Resultado estandarizado vía getResponse.
     */
    getAllUsersAsync: async ({ auth, languageId, subMethod = '' } = {}) => {
        const currentMethod = 'RoleService.getAllUsersAsync';
        let response = getResponse({ type: 0 });
        try {
            const requestObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.token?.token}`,
                },
                data: {
                    languageId: languageId,
                    method: settings?.backend?.methods?.roles?.getAllUsers,
                },
                url: `${settings?.backend?.urls?.api}${settings?.backend?.urls?.apiV1}${settings?.backend?.urls?.roles}/`,
                subMethod: subMethod || currentMethod,
            };
            response = await axios?.post(requestObj);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    },
};
